/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PhrMynaLinkStatusUnit,
  PhrMynaLinkStatusUnitFromJSON,
  PhrMynaLinkStatusUnitFromJSONTyped,
  PhrMynaLinkStatusUnitToJSON,
} from "./";

export const PhrMynaLinkStatusTypename = "PhrMynaLinkStatus" as const;

/**
 *
 * @export
 * @interface PhrMynaLinkStatus
 */
export interface PhrMynaLinkStatus {
  /**
   *
   * @type {PhrMynaLinkStatusUnit}
   * @memberof PhrMynaLinkStatus
   */
  medicalExpenseNotification: PhrMynaLinkStatusUnit;
  /**
   *
   * @type {PhrMynaLinkStatusUnit}
   * @memberof PhrMynaLinkStatus
   */
  medicalTreatment: PhrMynaLinkStatusUnit;
  /**
   *
   * @type {PhrMynaLinkStatusUnit}
   * @memberof PhrMynaLinkStatus
   */
  specificHealthCheckup: PhrMynaLinkStatusUnit;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMynaLinkStatus
   */
  readonly __typename?: string;
}

export function PhrMynaLinkStatusFromJSON(json: any): PhrMynaLinkStatus {
  return PhrMynaLinkStatusFromJSONTyped(json, false);
}

export function PhrMynaLinkStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrMynaLinkStatus {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMynaLinkStatusTypename,

    medicalExpenseNotification: PhrMynaLinkStatusUnitFromJSON(json["medical_expense_notification"]),
    medicalTreatment: PhrMynaLinkStatusUnitFromJSON(json["medical_treatment"]),
    specificHealthCheckup: PhrMynaLinkStatusUnitFromJSON(json["specific_health_checkup"]),
  };
}

export function PhrMynaLinkStatusToJSON(object?: PhrMynaLinkStatus | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    medical_expense_notification: PhrMynaLinkStatusUnitToJSON(value.medicalExpenseNotification),
    medical_treatment: PhrMynaLinkStatusUnitToJSON(value.medicalTreatment),
    specific_health_checkup: PhrMynaLinkStatusUnitToJSON(value.specificHealthCheckup),
  };
}
